import { render, staticRenderFns } from "./AlarmStatu.vue?vue&type=template&id=06fd4df6&scoped=true"
import script from "./AlarmStatu.vue?vue&type=script&lang=js"
export * from "./AlarmStatu.vue?vue&type=script&lang=js"
import style0 from "./AlarmStatu.vue?vue&type=style&index=0&id=06fd4df6&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd4df6",
  null
  
)

export default component.exports